module.exports = __webpack_public_path__ + "static/img/kl1350-663-37073p.802f76b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/kl1350-663-37073p.jpg
// module id = H+vu
// module chunks = 0